import React, { Component } from 'react'
import Modal from 'bisu-react-modal'

import FormChangeSemester from './form-change-semester'

class FormContainer extends Component {

  render() {
    const { session, onSubmit, handleClose, isOpen } = this.props

    return (
      <Modal handleClose={handleClose} isOpen={isOpen}>
        <FormChangeSemester
          value={session}
          onSubmit={onSubmit}
        />
      </Modal>
    )
  }
}

export default FormContainer



// WEBPACK FOOTER //
// ./src/components/ChangeSemester/form-container.js